// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const SEND_TO_DOCUMENT_STEP_SHAPES = [
  {
    stepType: PipelineStepType.SEND_TO_DOCUMENT,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Input saved results': {
        systemName: 'Input saved results',
        displayName: 'Input saved results',
        kind: PipelineStepDataKind.DATASET,
        isMulti: true,
        isRequired: false
      },
      'Input datasets': {
        systemName: 'Input datasets',
        displayName: 'Input datasets',
        kind: PipelineStepDataKind.DATASET,
        isMulti: true,
        isRequired: false
      },
      'Input charts': {
        systemName: 'Input charts',
        displayName: 'Input charts',
        kind: PipelineStepDataKind.CHART,
        isMulti: true,
        isRequired: false
      }
    },
    outputDataShapes: {},
    config: {
      documentId: {
        kind: 'domain',
        required: true,
        types: [
          'ENTRY',
          'DOCUMENT',
          'WORKSHEET'
        ]
      },
      sectionLayout: {
        kind: 'array',
        required: true,
        elementSpec: {
          kind: 'shape',
          required: true,
          fields: {
            sectionName: {
              kind: 'string',
              required: true
            },
            inputReferences: {
              kind: 'array',
              required: true,
              elementSpec: {
                kind: 'shape',
                required: true,
                fields: {
                  inputDataName: {
                    kind: 'enum',
                    required: true,
                    choices: [
                      'Input saved results',
                      'Input datasets',
                      'Input charts'
                    ]
                  },
                  inputDataIndex: {
                    kind: 'number',
                    required: true
                  }
                }
              }
            }
          }
        }
      },
      sectionIndex: {
        kind: 'integer',
        required: false
      },
      lockResultTables: {
        kind: 'boolean',
        required: false
      },
      hideAnalysisChip: {
        kind: 'boolean',
        required: false
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
